// extracted by mini-css-extract-plugin
export default {"header":"QeqBoGOs","mobile":"mobile","card":"HQHpgeYh","desktop":"desktop"};